import { render, staticRenderFns } from "./toppurchase.vue?vue&type=template&id=4bf44b18&scoped=true&"
import script from "./toppurchase.vue?vue&type=script&lang=js&"
export * from "./toppurchase.vue?vue&type=script&lang=js&"
import style0 from "./toppurchase.vue?vue&type=style&index=0&id=4bf44b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf44b18",
  null
  
)

export default component.exports